document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.custom-blog-header');
  const menuToggle = document.querySelector('.custom-blog-header__menu-toggle');
  const mobileMenu = document.getElementById('MobileMenu');

  function setHeaderHeight() {
    if (!header) return;
    document.documentElement.style.setProperty(
      '--custom-blog-header-height',
      `${header.offsetHeight}px`
    );
  }

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  function setMenuOpen(isOpen) {
    if (!mobileMenu || !menuToggle) return;

    mobileMenu.classList.toggle('is-open', isOpen);
    menuToggle.classList.toggle('is-open', isOpen);
    menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    menuToggle.setAttribute(
      'aria-label',
      isOpen ? menuToggle.dataset.labelClose : menuToggle.dataset.labelOpen
    );
    document.body.classList.toggle('custom-blog-header-menu-open', isOpen);
  }

  const searchArea = document.querySelector('.custom-blog-header__search');
  const mobileSearchBtn = document.querySelector('.custom-blog-header__mobile-search-btn');
  const searchContainer = document.querySelector('.custom-blog-header__search-form-container');

  function setSearchOpen(isOpen) {
    if (!header || !searchArea || !searchContainer || !mobileSearchBtn) return;

    header.classList.toggle('is-search-open', isOpen);
    searchArea.classList.toggle('is-search-open', isOpen);
    searchContainer.classList.toggle('is-open', isOpen);
    mobileSearchBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (isOpen) {
      const searchInput = searchContainer.querySelector('input[type="search"]');
      if (searchInput) searchInput.focus();
      setHeaderHeight();
    } else {
      setHeaderHeight();
    }
  }

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      const willOpen = !mobileMenu.classList.contains('is-open');
      setMenuOpen(willOpen);
      if (willOpen) setSearchOpen(false);
    });
  }

  if (mobileSearchBtn && searchContainer) {
    mobileSearchBtn.addEventListener('click', function(event) {
      event.stopPropagation();
      setSearchOpen(!header.classList.contains('is-search-open'));
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') setSearchOpen(false);
    });

    document.addEventListener('click', function(event) {
      if (!header.classList.contains('is-search-open')) return;
      if (searchArea.contains(event.target)) return;
      setSearchOpen(false);
    });
  }

  const searchForm = document.querySelector('.custom-blog-header__search-form-container form');
  if (searchForm) {
    searchForm.addEventListener('submit', function(event) {
      const searchInput = this.querySelector('input[name="q"]');
      if (!searchInput.value.trim()) {
        event.preventDefault();
      }
    });
  }
});
